var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noData"},[_c('img',{attrs:{"src":require("@/assets/home/nodata.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title || _vm.$t("home.nodata")))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca85884a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noData.vue
// module id = null
// module chunks = 